export default `
  query cardTypes($workflowId: ID!) {
    cardTypes(workflowId: $workflowId) {
      id
      title
      description
      color {
        red
        green
        blue
        rgb
      }
      showInBacklog
      generateWithAI
      domainModelRole
      defaultType
      order
    }
  }
`
